<template>
  <div class="village-detail-page">
   
      <h2 class="page-title">{{ villageName }} · 村组详情</h2>

      <!-- Stats Cards Row -->
      <section class="stats-row">
        <div class="stat-card stat-card--blue">
          <div class="stat-icon">🏠</div>
          <div class="stat-info">
            <span class="stat-label">总门牌号</span>
            <span class="stat-value">{{ stats.menpainums }}</span>
          </div>
        </div>
        <div class="stat-card stat-card--orange">
          <div class="stat-icon">📋</div>
          <div class="stat-info">
            <span class="stat-label">异常门牌号数</span>
            <span class="stat-value">{{ stats.errhushu }}</span>
          </div>
        </div>
        <div class="stat-card stat-card--blue">
          <div class="stat-icon">👥</div>
          <div class="stat-info">
            <span class="stat-label">总用气人数</span>
            <span class="stat-value">{{ stats.psersonnums }}</span>
          </div>
        </div>
        <div class="stat-card stat-card--red">
          <div class="stat-icon">⚠️</div>
          <div class="stat-info">
            <span class="stat-label">异常总人数</span>
            <span class="stat-value">{{ stats.errperson }}</span>
          </div>
        </div>
        <div class="stat-card stat-card--green">
          <div class="stat-icon">✅</div>
          <div class="stat-info">
            <span class="stat-label">已整改数</span>
            <span class="stat-value">{{ stats.zhenggainums }}</span>
          </div>
        </div>
      </section>

      <!-- Full-width Bar Chart -->
      <section class="chart-section">
        <h3 class="card-title">{{ villageName }} · 燃气厂家分布</h3>
        <div class="bar-chart">
          <div id="gasDistChart" style="width: 100%; height: 200px;"></div>
        </div>
      </section>

      <!-- Table Section -->
      <section class="table-section">
        <h3 class="card-title">近期整改记录</h3>
        <el-table
          :data="rectifyRecords"
          border
          stripe
          style="width: 100%"
          size="small"
          header-cell-class-name="table-header-cell"
        >
          <el-table-column prop="create_time" label="时间"  width="150" />
          <el-table-column prop="regionname" label="组名" />
          <el-table-column prop="name" label="姓名" />
          <el-table-column prop="identity" label="身份" />
          <el-table-column prop="phone" label="联系方式" />
          <el-table-column prop="gas_supplier" label="燃气厂家" />
          <el-table-column label="安心管">
            <template slot-scope="scope">
              {{ scope.row.pipe_safe == '0' ? '正常' : '异常' }}
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" show-overflow-tooltip />
          <el-table-column prop="create_man" label="操作员" />
          <el-table-column label="状态">
            <template slot-scope="scope">
              <el-tag
                :type="scope.row.is_abnormal == '0' ? 'success' : 'danger'"
                size="small"
                effect="plain"
              >{{ scope.row.is_abnormal == '0' ? '正常' : '异常' }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="update_time" label="整改时间"  width="150" />
        </el-table>
      </section>

  </div>
</template>

<script>

import { getGasOverview, getUserpageList, getGasRunDistribution } from '@/api/gasdashboard'
export default {
  name: 'VillageDetail',
  data() {
    return {
      villageName: this.$route.query.regionname,
      regionCode: this.$route.query.regioncode,
      stats: {
        menpainums: 0,
        psersonnums: 0,
        errperson: 0,
        errhushu: 0,
        zhenggainums: 0
      },
      hazardDistribution: [
        { name: '安心管异常', count: 1, percent: 50, color: 'danger' },
        { name: '灶具不合格', count: 1, percent: 50, color: 'warning' },
        { name: '气瓶厂家异常', count: 0, percent: 0, color: 'primary' }
      ],
      rectifyRecords: [],
      gasDistChart: null
    }
  },
  mounted() {
    this.getInfo();
    this.getUserList();
    this.getYinhuan();
    window.addEventListener('resize', this.handleChartResize);
  },
  beforeDestroy() {
    if (this.gasDistChart) {
      this.gasDistChart.dispose();
    }
    window.removeEventListener('resize', this.handleChartResize);
  },
  methods: {
    getInfo() { 
        getGasOverview({
            'x-access-token': this.GLOBAL.token(),
            userid: this.GLOBAL.adminId(),
            regioncode: this.regionCode
        }).then((res) => {
            if (res.result == '200') {
                this.stats = res.detail;
            } else {
                this.$message.error(res.description);
            }
        })
    },
    
    getUserList(){
        getUserpageList({
            'x-access-token': this.GLOBAL.token(),
            userid: this.GLOBAL.adminId(),
            page: 1,
            pagesize: 10,
            regioncode: this.regionCode
        }).then((res) => {
            if (res.result == '200') {
                this.rectifyRecords = res.detail.list;
            } else {
                this.$message.error(res.description);
            }
        })
    },
    //燃气厂家分布
    getYinhuan() {
        getGasRunDistribution({
            'x-access-token': this.GLOBAL.token(),
            userid: this.GLOBAL.adminId(),
            regioncode: this.regionCode
        }).then((res) => {
            if (res.result == '200') {
                console.log(res);
                this.xAxisData = res.detail.ranqilist[0].names.split(',');
                this.yAxisData = res.detail.ranqilist[0].nums.split(',');
                this.initGasDistChart();
            } else {
                this.$message.error(res.description);
            }
        })
    },
    // 初始化图表
    initGasDistChart(){
        this.gasDistChart = this.$echarts.init(document.getElementById('gasDistChart'));
        this.gasDistChart.setOption({
           grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            xAxis: {
                type: 'category',
                data: this.xAxisData
            },
            yAxis: {
                type: 'value',
            },
            series: [
                {
                    data: this.yAxisData,
                    type: 'bar',
                    label: {
                        show: true,
                        position: 'top'
                    },
                    barMaxWidth: 50
                }
            ]
        })
    },
    handleChartResize() {
      if (this.gasDistChart) {
        this.gasDistChart.resize();
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import "./variables.scss";
// ========== Layout ==========
.village-detail-page {
  background-color: $page-bg;
  padding: 12px;
  min-height: calc(100vh - 100px);
  box-sizing: border-box;
}

.page-title {
    font-size: $font-size-xl;
    font-weight: 600;
    color: $text-primary;
    margin-bottom: $spacing-lg;
  }
  


// ========== Stats Cards ==========
.stats-row {
  display: flex;
  gap: $spacing-md;
  margin-bottom: $spacing-lg;

  .stat-card {
    flex: 1;
    background: $card-bg;
    border-radius: $radius-md;
    padding: $spacing-lg $spacing-md;
    display: flex;
    align-items: center;
    gap: $spacing-md;
    box-shadow: $shadow-sm;
    border-left: 4px solid transparent;

    &:nth-child(1) { border-left-color: $primary; }
    &:nth-child(2) { border-left-color: $primary; }
    &:nth-child(3) { border-left-color: $danger; }
    &:nth-child(4) { border-left-color: $warning; }
    &:nth-child(5) { border-left-color: $success; }

    .stat-icon {
      font-size: 28px;
      width: 48px;
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: $radius-sm;
    }

    .stat-info {
      display: flex;
      flex-direction: column;

      .stat-label {
        font-size: $font-size-sm;
        color: $text-secondary;
        margin-bottom: $spacing-xs;
      }

      .stat-value {
        font-size: 28px;
        font-weight: 700;
        color: $text-primary;
      }
    }
  }
}

// ========== Chart Section ==========
.chart-section {
  background: $card-bg;
  border-radius: $radius-md;
  padding: $spacing-lg;
  box-shadow: $shadow-sm;
  margin-bottom: $spacing-lg;

  .card-title {
    font-size: $font-size-lg;
    font-weight: 600;
    color: $text-primary;
    margin-bottom: $spacing-lg;
  }
}

.bar-chart {
  display: flex;
  flex-direction: column;
  gap: $spacing-lg;
  padding: $spacing-sm 0;

  .bar-item {
    display: flex;
    align-items: center;
    gap: $spacing-md;
  }

  .bar-label {
    width: 110px;
    font-size: $font-size-base;
    color: $text-primary;
    text-align: right;
    flex-shrink: 0;
  }

  .bar-track {
    flex: 1;
    height: 24px;
    background: #E8EDF2;
    border-radius: 12px;
    overflow: hidden;
  }

  .bar-fill {
    height: 100%;
    border-radius: 12px;
    transition: width 0.6s ease;

    &--danger { background: $danger; }
    &--warning { background: $warning; }
    &--primary { background: $primary; }
  }

  .bar-value {
    width: 60px;
    font-size: $font-size-sm;
    color: $text-secondary;
    flex-shrink: 0;
  }
}

// ========== Table Section ==========
.table-section {
  background: $card-bg;
  border-radius: $radius-md;
  padding: $spacing-lg;
  box-shadow: $shadow-sm;

  .card-title {
    font-size: $font-size-lg;
    font-weight: 600;
    color: $text-primary;
    margin-bottom: $spacing-md;
  }
}

// ========== Table Header Style ==========
:deep(.table-header-cell) {
  font-weight: 600;
  color: $text-secondary;
  background: $table-header-bg;
}
</style>
